export default {
  de: 'Deutsch',
  en: 'English',
  formattypes: {
    selection: 'Formatting of date fields',
    iso: 'ISO format (YYYY-MM-DD HH:mm)',
    de: 'German (DD.MM.YYYY HH:mm)',
    en: 'English (MM/DD/YYYY HH:mm)'
  },
  themes: {
    dark: 'Dark user interface',
    light: 'Light user interface'
  },
  denses: {
    false: 'Normal mode',
    true: 'Dense mode'
  },
  actions: {
    cancel: 'Cancel',
    ok: 'OK',
    save: 'Save',
    discard: 'Don\'t save',
    close: 'Close',
    logout: 'Log-out',
    all: 'All',
    apply: 'Apply',
    go: 'Go',
    delete: 'Delete',
    edit: 'Edit',
    csv: 'Export to CSV',
    import: 'Import',
    invite: 'Invite',
    accept: 'Accept',
    clone: 'Clone',
    reset: 'Reset formular',
    undo: 'Undo',
    send: 'Send',
    export: 'Export',
    exportXlsx: 'Export to XLSX',
    clear: 'Clear',
    pdf: 'Create PDF',
    image: 'Create image',
    create: 'Create',
    saveAndClose: 'Save and close'
  },
  user: {
    loggedInAs: 'Logged in as',
    settings: 'Settings',
    settingsMore: 'User settings..'
  },
  options: {
    title: 'User settings',
    messages: 'Messages',
    hints: 'Hints',
    theme: 'Dark theme',
    dense: 'Dense mode',
    autoReload: 'Automatic refresh',
    themes: 'Color design of the user interface',
    denses: 'Increase or decrease the size of the user interface elements',
    copies: 'CC and BCC for email sending',
    cc: 'Carbon copy (CC)',
    bcc: 'Blind carbon copy (BCC)',
    emailHint: 'Enter a valid email address and confirm the input with Enter.',
    tree: {
      gui: 'User interface',
      language: 'Language',
      dateformat: 'Date format',
      theme: 'Colors / Theme',
      dense: 'Dense mode',
      mailing: 'Mailing',
      copies: 'Copies'
    }
  },
  locales: {
    selection: 'Select language'
  },
  tour: {
    labels: {
      buttonSkip: 'Skip tour',
      buttonPrevious: 'Previous',
      buttonNext: 'Next',
      buttonStop: 'Finish'
    }
  },
  routes: {
    home: 'Overview',
    organizations: 'Organizations',
    staff: 'Employees',
    templates: 'Templates',
    coaching: 'Coachings',
    reporting: 'Reporting'
  },
  home: {
    finished: 'Finished',
    grade12: 'excellent, good',
    grade34: 'satisfactory, poor',
    grade56: 'failure',
    avgDuration: 'Average duration',
    avgRating: 'Average rating',
    reminder: 'Reminder',
    showExpired: 'Show expired',
    createdCoachings: 'New created coachings',
    finishedCoachings: 'Finished coachings',
    lastHour: 'Last hour',
    lastDay: 'Last day',
    newLastHour: 'New',
    newLastDay: 'New',
    finishedLastHour: 'Finished',
    finishedLastDay: 'Finished',
    openSelection: 'Select filter',
    averageTemplateRating: 'Average rating per template',
    createPDF: 'Create PDF from overview',
    summaryTitle: 'Overview',
    pdfFilename: 'coaching-overview-{date}.pdf',
    createImage: 'Create image from overview',
    imageFilename: 'coaching-overview-{date}.png',
    summaryProcessing: 'PDF is created. One moment of patience please...'
  },
  drawer: {
    changePassword: 'Change password',
    changelog: 'Changelog',
    feedback: 'Feedback to support',
    calendar: 'Show calendar',
    adminPage: 'Administration'
  },
  organisation: {
    label: 'Organizations',
    missingTitle: 'You are not yet assigned to an organization',
    missingText: 'Switch to the ORGANIZATIONS tab and create a new organization to which you will then be automatically assigned.',
    selectHeader: 'YOUR ORGANIZATIONS',
    delete: 'Really delete organization?',
    name: 'Name of the organization',
    description: 'Description of the organization',
    initials: 'Initials of the organization',
    confirmDeleteHint: 'This is a security prompt to prevent you from accidentally deleting the wrong organization.',
    confirmInvalid: 'Name of the organization does not match.',
    invite: 'Invite user to organization',
    inviteSuccess: 'Invitation was sent out',
    email: 'E-Mail of the user',
    emailHint: 'For a user who does not yet exist, a registration is performed.',
    emailEmpty: 'E-Mail is required',
    emailInvalid: 'E-Mail is not valid',
    create: 'Create organization',
    edit: 'Edit organization',
    deleteLabel: 'Enter the name of the organization here',
    selection: {
      title: 'Select organizations',
      titleSingle: 'Select organization',
      copyHint: 'To which organizations should the template be copied?',
      createHint: 'In which organization should the coaching be created?'
    }
  },
  template: {
    label: 'Templates',
    created: 'New template',
    delete: 'Really delete template?',
    missingConfigTitle: 'Template not saveable',
    missingConfigText: 'No fields defined.',
    create: 'Create template',
    edit: 'Edit template',
    metadata: 'Description',
    blocks: 'Building blocks',
    buildingBlocks: 'Building blocks',
    exists: 'exists',
    initialsAutoPrefix: 'TEMPLATE-',
    blockCreated: 'Building block was saved',
    confirmCancelTitle: 'Save your changes?',
    confirmCancelDescription: 'The template was edited.',
    copied: 'The template was copied!',
    saved: 'The template was saved!'
  },
  employee: {
    label: 'Employees',
    organizationGroup: 'Group',
    organizationGroupHint: 'Depending on the selected group, the employee receives different permissions',
    username: 'Employee',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'E-Mail',
    isActive: 'Active',
    all: 'All',
    active: 'Only active',
    inactive: 'Only inactive',
    delete: 'Really delete employee?',
    import: 'Import employees',
    importText: 'Creation of employees via text or file import',
    importHint: 'Delimited by comma or semikolon (Group, E-Mail, Username, Firstname, Lastname). One line per employee.',
    created: 'New employees created',
    create: 'Create employee',
    edit: 'Edit employee',
    invite: 'Send invitation by e-mail',
    added: 'Employee added',
    invitations: 'Invitations',
    inviteDelete: 'Really delete invitation?',
    organizationItemText: 'With which group an invitation or registration mail is sent'
  },
  groups: {
    EmployeeDumb: 'Employee without login',
    EmployeeSane: 'Employee with e-mail',
    EmployeeSmart: 'Employee with login',
    Administrator: 'Administrator',
    Coach: 'Coach',
    Disabled: 'Deactivated'
  },
  coaching: {
    preview: 'Preview',
    planning: 'Plan Coaching',
    selectEmployee: 'Select employee',
    hintEmployee: 'For which employees should the coaching be carried out? (only active employees are available)',
    noEmployee: 'No employees available',
    selectTemplate: 'Select template',
    hintTemplate: 'Which template should be used?',
    delete: 'Really delete coaching?',
    edit: 'Really edit coaching?',
    editHint: 'Coaching has already been marked as completed.',
    clone: 'Really clone coaching?',
    cloneHint: 'Employee and template are adopted and a new coaching is created.',
    summaryProcessing: 'PDF is created. One moment of patience please...',
    summaryTitle: 'Coaching Summary',
    finishAction: 'Finish coaching',
    finishActionError: 'There are blocks that have no valid input!',
    finishMessage: 'Mark coaching as finished?',
    finishDescription: 'The coaching is hidden and included in the statistics on the overview page.',
    finishSubmit: 'Mark',
    confirmCancelTitle: 'Save your changes?',
    confirmCancelDescription: 'The coaching was edited.',
    newTextOne: 'A new coaching was created',
    newText: '<% len %> new coachings were created',
    open: 'Show coaching',
    pdfFilename: 'coaching-report-{date}.pdf',
    imageFilename: 'coaching-report-{date}.png',
    pdfFilenamePlanning: 'coaching-planning-{date}.pdf',
    imageFilenamePlanning: 'coaching-planning-{date}.png',
    pdfSelectionTitle: 'Select options for PDF',
    pdfSelectionDescription: '',
    pdfWithRadar: 'Append radar chart?',
    pdfWithNoRating: 'Append building blocks with no rating?',
    startTimer: 'Start timer',
    stopTimer: 'Stop timer',
    resetTimer: 'Reset timer',
    undoResetTimer: 'Undo reset',
    search: 'Search coachings',
    noRatingHintShort: 'NR',
    noRatingHint: 'NR = no rating',
    emailSent: 'Email was sent',
    saved: 'The coaching was saved!'
  },
  compare: {
    title: 'Compare coachings',
    actions: {
      collapseAll: 'Collapse all',
      expandAll: 'Expand all',
      radar: 'Radar',
      toggleRadar: 'Show/hide radar'
    }
  },
  cas: {
    label: 'Advanced search'
  },
  entity: {
    user: 'User',
    initials: 'Initials',
    name: 'Name',
    description: 'Description',
    employee: 'Employee',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'E-Mail',
    isActive: 'Active',
    finished: 'Finished',
    finishedFrom: 'Finished from',
    finishedDate: 'Finished date',
    finishedTime: 'Finished time',
    template: 'Template',
    result: 'Result',
    duration: 'Duration',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    filter: 'Filter by...',
    process: 'Process',
    created: 'Created',
    view: 'View',
    clone: 'Clone',
    date: 'Date',
    time: 'Time',
    summary: 'Summary',
    weighting: 'Weighting',
    rating: 'Rating',
    ratingWeighted: 'Weighted rating',
    timer: 'Timer',
    sheet: 'Coaching sheet',
    report: 'Report',
    total: 'Total',
    note: 'Note',
    totalweighted: 'Weighted total',
    noteweighted: 'Weighted note',
    error: 'Error',
    reminder: 'Reminder',
    scriptureUser: 'Scripture user',
    scriptureEmployee: 'Scripture employee',
    group: 'Group',
    invitation: 'Invitation',
    expires: 'Expires in',
    expiresFromNow: 'from now',
    pending: 'Pending',
    state: 'State',
    link: 'Link',
    internal: 'Intern',
    pdf: 'PDF',
    pdfcreate: 'Create PDF',
    print: 'Print',
    send: 'Send',
    sort: 'Sort by',
    asc: 'ascending',
    desc: 'descending',
    copy: 'Copy',
    average: 'Average',
    compare: 'Compare',
    voixenid: 'ID of the recording from VIER Interaction Analytics',
    voixenuser: 'VIER User',
    summaryBuildingBlocks: 'Summary building blocks',
    blocks: 'Blocks'
  },
  coachingUnit: {
    label: 'Coaching Units',
    create: 'Create Coaching Unit',
    edit: 'Edit Coaching Unit',
    delete: 'Really delete coaching unit?',
    setDone: 'Mark as done?',
    setDoneHint: 'This action is irreversible. Afterwards no coachings can be added or edited.',
    setDoneSubmit: 'Finish',
    isDone: 'Done',
    isOpen: 'Open',
    name: 'Unit name',
    startDate: 'Start date',
    endDate: 'End date',
    score: 'Score',
    addCoaching: 'Add coaching',
    noCoachings: 'No coachings in this unit',
    selectEmployee: 'Select employee',
    saved: 'Coaching unit was saved!'
  },
  notes: {
    name: 'Notes',
    initials: 'NOTES',
    description: 'Only for internal use',
    private: 'Notes only for coach visible?'
  },
  register: {
    label: 'Register',
    username: 'Username',
    password: 'Password',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'E-Mail',
    agree: 'I agree to the terms and conditions',
    submit: 'Perform registration',
    pwTitle: 'Choose a password',
    toastTitle: 'Registration successfully completed',
    toastText: 'With receipt of the activation mail you complete the process.',
    termsofuse: 'call here',
    oldPw: 'Old password',
    oldPwHint: 'So that only you can assign a new password, enter your old password.',
    newPw: 'New password',
    newPwHint: 'Input must be at least 8 characters long, contain a capital letter and a number.',
    newPwInvalid: 'The password must contain at least one capital letter and one number.',
    newPwConfirm: 'Confirm new password',
    newPwConfirmHint: 'For security and to avoid incorrect entries, enter the password again.',
    usernameExists: 'Username already exists.',
    failedTitle: 'Registration failed',
    failedSubtitle: 'Registration already completed or link is no longer valid.',
    processingTitle: 'Registration is completed',
    processingSubtitle: 'One moment of patience please...',
    doneTitle: 'Registration has been completed',
    doneSubtitle: 'You can log in now.'
  },
  password: {
    oldLabel: 'Old password',
    newLabel: 'New password',
    confirmLabel: 'Confirm new password',
    confirmHint: 'For security and to avoid incorrect entries, enter the password again.',
    changed: 'Password changed'
  },
  login: {
    label: 'Login',
    username: 'Username / E-Mail',
    password: 'Password',
    submit: 'log-in',
    authError: 'Log-in failed!',
    resetPassword: 'Forgot password',
    resetPasswordSuccess: 'E-mail was sent to the user'
  },
  app: {
    imprint: 'Imprint',
    privacy: 'Data Privacy',
    toc: 'Terms of use',
    agb: 'Terms and conditions',
    disclaimer: 'Disclaimer'
  },
  settings: {
    startTour: 'Start tutorial',
    showMessages: 'Show messages'
  },
  search: {
    noFilter: 'All',
    activeFilter: 'Active filter',
    ignoreFinished: 'Show all coachings',
    finished: 'Show finished coachings',
    notFinished: 'Show not finished coachings',
    periodOfTime: 'Time period',
    periodOfTimeCreated: 'Created',
    periodOfTimeFinished: 'Finished',
    durationRating: 'Duration and rating',
    rangeCreated: 'Time range for new created coachings',
    rangeFinished: 'Time range for finished coachings',
    from: 'from',
    until: 'until',
    employees: 'Employees',
    coach: 'Coach',
    contains: 'contains',
    filtertext: 'Filter by..',
    datefrom: 'Startdate',
    timefrom: 'Starttime',
    dateto: 'Enddate',
    timeto: 'Endtime',
    templates: 'Templates',
    blocks: 'Building blocks',
    durationfrom: 'Duration from',
    durationto: 'Duration to',
    ratingfrom: 'Rating from',
    ratingto: 'Rating to',
    saveTitle: 'Save search',
    saveName: 'Name of search',
    saveSelect: 'Choose search',
    relTime: {
      title: 'Period of time',
      all: 'All',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      last2Month: 'Last 2 months',
      last3Month: 'Last 3 months',
      last6Month: 'Last 6 months',
      thisYear: 'This year',
      lastYear: 'Last year'
    }
  },
  reporting: {
    tempMessage: 'In February 2020 you will find here the evaluations of the coaching sessions carried out.',
    title: 'Increase in employee productivity through targeted coaching',
    xLabel: 'Month',
    yLabel: 'Rating',
    ds1Label: 'Result of their employees',
    ds2Label: 'before the use of VIER Scorecards',
    treemapEmployee: 'Performed coaching per employee and template',
    treemapTemplate: 'Performed coaching per template and employee',
    treemapAll: 'All existing coachings',
    linechartTitle: 'Coaching-Performance',
    soEmpty: 'For this organization there are no coaching sessions for evaluation!',
    templatesHint: 'For which template would you like to see the development?',
    actions: {
      collapseAll: 'Collapse all',
      expandAll: 'Expand all'
    }
  },
  messages: {
    title: 'Messages',
    acceptInvitation: 'Accept invitation',
    expiredInvitation: 'Invitation',
    expiredLink: 'This link has expired and can no longer be used!',
    emailInvalid: 'E-Mail is not valid'
  },
  gf: {
    firstname: 'Firstname',
    lastname: 'Lastname',
    street: 'Street',
    housenumber: 'House number',
    zipcode: 'Zip code',
    city: 'City',
    country: 'Country',
    county: 'County',
    phone: 'Phonenumber',
    email: 'E-Mail',
    duration: 'Duration',
    adult: 'Over 18 years?',
    rating: 'Rating',
    combo: 'Hobby',
    comment: 'Comment',
    info: 'Information',
    date: 'Date',
    required: '* = Required',
    optional: 'Optional'
  },
  teaser: {
    text1: 'Create, plan and execute digital employee coaching sessions.',
    text2: 'Freely configurable forms, intuitive templates,',
    text3: 'clear employee lists and flexible evaluations',
    text4: 'make it easier than ever before,',
    text5: 'in the development of your employees',
    text6: 'to be the decisive step ahead.'
  },
  offer: {
    headline: 'Digital Scorecards',
    subtitle: 'In 5 minutes to the digitalized coaching process! From 5€ per month.',
    primary: 'Test now free of charge and without obligation for 30 days*',
    footer: '* The test phase ends automatically after 30 days. You then decide yourself whether and how you want to continue.'
  },
  cancelled: 'Cancelled',
  errors: {
    title: 'Problem',
    defaultMessage: 'An unexpected error has occurred!',
    status403Message: 'Access has been denied!'
  }
}
